import { Container, Stack } from "@mui/material";
import React from "react";

import Typography from "@mui/material/Typography";

export default function Badge() {
  return (
    <Container maxWidth="xl">
      <>
        <Stack direction="column" justifyContent="center" alignItems="center">
          <Typography
            component="div"
            color="secondary.contrastText"
            sx={{ my: 1, fontSize: "3em", mt: 25 }}>
            Coming Soon
          </Typography>
        </Stack>
      </>
    </Container>
  );
}
